/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import Modal from '@/components/ModalV2';
import styles from '../MobileBlogMenuNavigation.module.scss';

type MobileBlogMenuModalProps = {
  isOpen: boolean;
  handleClose?: () => void;
  title: string;
  children: React.ReactNode;
};

export const MobileBlogMenuModal = ({
  isOpen,
  handleClose,
  title,
  children,
}: MobileBlogMenuModalProps) => {
  return (
    <Modal
      title={title}
      body={children}
      isOpen={isOpen}
      handleClose={handleClose}
      modalClasses={{
        root: styles.modalRoot,
        title: styles.modalTitle,
      }}
      showCloseButton
    />
  );
};
